export var SHOW_SEARCH_PANEL = 'CUSTOMER_SEARCH_SHOW_SEARCH_PANEL';
export var showSearchPanel = function showSearchPanel() {
  return {
    type: SHOW_SEARCH_PANEL
  };
};
export var HIDE_SEARCH_PANEL = 'CUSTOMER_SEARCH_HIDE_SEARCH_PANEL';
export var hideSearchPanel = function hideSearchPanel() {
  return {
    type: HIDE_SEARCH_PANEL
  };
};
export var SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
export var setSearchType = function setSearchType(payload) {
  return {
    type: SET_SEARCH_TYPE,
    payload: payload
  };
};
export var CLEAR_RESULTS = 'SEARCH_CLEAR_RESULTS';
export var clearSearchResults = function clearSearchResults() {
  return {
    type: CLEAR_RESULTS
  };
};
export var CLEAR_SEARCH_ERROR = 'CLEAR_SEARCH_ERROR';
export var clearSearchError = function clearSearchError() {
  return {
    type: CLEAR_SEARCH_ERROR
  };
};